import { useQuery } from 'react-query'
import { api } from '../api'
import { ApiUrlEnum } from '../../enums/ApiUrlEnum'
import { QueryKeyEnum } from '../../enums/QueryKeyEnum'

export const useGetCalendarData = (projectId: string) => {
  return useQuery({
    queryFn: () =>
      api.get<
        {
          date: string
          isSigned: boolean
        }[]
      >(`${ApiUrlEnum.PROJECT}/${projectId}${ApiUrlEnum.CONSTRUCTION_DIARY}/calendar`),
    queryKey: [QueryKeyEnum.CONSTRUCTION_DIARY, 'calendar'],
  })
}
